<template>
  <div class="goodTerms">
    <transition name="auth-router" mode="out-in">
      <router-view class="router" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "GoodsTerms",
  data() {
    return {
      path: "",
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.goodTerms {
  display: inline-block;
  width: 100%;
}
</style>
